// extracted by mini-css-extract-plugin
module.exports = {"SLoaderContainer":"PleaseWait_SLoaderContainer__prawL","Spinner":"PleaseWait_Spinner__fJp9P","rotation":"PleaseWait_rotation__DvqU_"};